import { isNil } from 'lodash'
import { DECLARATION_STATUS } from '../agriAdministration/constants/AgriConstants'

const DECLARATION_NB_STEPS = 4
const UNFINALIZED_MAX_ADVANCEMENT = 90

export const getDeclarationAdvancement = ({ lastStep, statusCode }) => {
    if (isNil(lastStep)) {
        return 0
    }
    const maxAdvancement = statusCode >= DECLARATION_STATUS.FINALIZED_BY_AGRI ? 100 : UNFINALIZED_MAX_ADVANCEMENT
    return Math.min((lastStep * 100) / DECLARATION_NB_STEPS, maxAdvancement)
}
